import Button from '../../../components/ui/Button';

interface ActionButtonsProps {
  onAccept: () => void;
  isApproved: boolean;
  isProcessing: boolean;
}

const ActionButtons = ({
  onAccept,
  isApproved,
  isProcessing,
}: ActionButtonsProps) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 sticky top-4">
      <div className="space-y-4">
        {!isApproved ? (
          <>
            <Button
              variant="success"
              size="lg"
              fullWidth
              iconName="Check"
              iconPosition="left"
              onClick={onAccept}
              disabled={isProcessing}
              loading={isProcessing}
            >
              Accept Quote
            </Button>
            <p className="text-xs text-text-secondary text-center">
              By accepting, you agree to the terms and conditions outlined in this quote
            </p>
          </>
        ) : (
          <div className="bg-success/10 rounded-lg p-4 text-center">
            <div className="w-12 h-12 bg-success rounded-full flex items-center justify-center mx-auto mb-3">
              <svg
                className="w-6 h-6 text-success-foreground"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <p className="text-sm font-medium text-success mb-1">Quote Approved</p>
            <p className="text-xs text-text-secondary">
              Thank you for your approval. A confirmation has been sent to your email.
            </p>
          </div>
        )}

        <div className="pt-4 border-t border-border">
          <p className="text-xs text-text-secondary mb-2">Need help?</p>
          <div className="flex items-center gap-2 text-xs text-text-primary">
            <svg
              className="w-4 h-4 text-primary"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            <a
              href="mailto:sales@evoqia.eu"
              className="hover:text-primary transition-colors"
            >
              sales@evoqia.eu
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionButtons;